// generated file, if you want to edit this file manually change the word "generated" to "manual"
import MaterialAppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import React from "react";
import { excludeKeys, makeThemedStyles } from "./../utils";
const useStylesForAppBar = makeThemedStyles("AppBar", (theme) => ({
  AppBar: {},
}));
type PropType = React.ComponentProps<typeof MaterialAppBar>;
export const AppBar: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForAppBar();
  const enabledClasses = excludeKeys(styles, ["AppBar", "Icons", "UserMenu"]);
  /* eslint-disable */
  return (
    <MaterialAppBar
      {...props}
      classes={{
        root: styles.AppBar,
        ...enabledClasses,
      }}
      style={{ zIndex: 99999 }}
      className={clsx(styles.AppBar)}
    >
      {props?.children}
    </MaterialAppBar>
  );
};
export default AppBar;
